var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityHistoryFilterNotifications = function SvgActivityHistoryFilterNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19345_59708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 12.6733L6.45873 12.9033C6.73339 13.7013 7.60273 14.1253 8.40073 13.8507C9.19873 13.576 9.62273 12.7067 9.34806 11.9087L9.26873 11.6787",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32315 3.46933L7.12382 2.89066C6.90382 2.25266 6.20848 1.91333 5.56982 2.13333C4.93182 2.35333 4.59248 3.04866 4.81182 3.68666L5.01115 4.26533",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70257 7.844C3.15924 6.26666 3.99791 4.54733 5.57524 4.004L6.71791 3.61066C8.29524 3.06733 10.0146 3.906 10.5579 5.48333L11.1646 7.246C11.2799 7.58066 11.5232 7.85533 11.8406 8.01L12.3839 8.27466C12.7019 8.43 12.9452 8.70466 13.0599 9.03866C13.2866 9.69666 12.9366 10.414 12.2786 10.6407L5.52191 12.9673C4.86391 13.194 4.14657 12.844 3.91991 12.186C3.80457 11.8513 3.82724 11.4853 3.98191 11.1673L4.24657 10.624C4.40191 10.306 4.42391 9.94 4.30857 9.60533L3.70257 7.844Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19345_59708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgActivityHistoryFilterNotifications as ReactComponent };
export default __webpack_public_path__ + "activity-history-filter-notifications.svg";